import { useSuspenseGetSharedFunctionality } from '../../../api/lending/lapiHooks.suspense';

export function useIsInvoiceFinanceSignup(): boolean {
  const { functionality } = useSuspenseGetSharedFunctionality({
    functionalities: ['can_buyer_be_evaluated_for_invoice_finance'],
  });

  return functionality?.can_buyer_be_evaluated_for_invoice_finance ?? false;
}
